module.exports = __webpack_public_path__ + "img/photo.56757de4.svg";